/** @jsx jsx */
import { jsx, css } from '@emotion/react';
import { Component, FormEvent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import moment from 'moment';
import { AppState } from '../../app.state';
import Link from '../../_shared/link';
import FormTitle from '../../_shared/form-title';
import {
  TandemGroup,
  _TandemGroup,
} from '../../_shared/interfaces/tandemGroup';
import { chain, get, set } from 'lodash';
import styles from './edit-tandem-group.styles';
import { Alert, message, Checkbox, Modal } from 'antd';
import {
  buildErrorMsgFromForm,
  userHasRole,
  uppercaseWords,
  isServiceOrgAdmin,
  sortByLabel,
  getEquipmentType,
  sortByKey,
  isPB,
  getEquipConfig,
  getEquipmentModel,
  getDeviceStatusFromEquip,
  generateTGDeviceCMD,
  TG_ROLES,
  cleanCopy,
  stopProp,
} from '../../utils';
import { Button } from '../../_shared/button';
import { Org } from '../../_shared/interfaces/org';
import { Location } from '../../_shared/interfaces/location';
import { Equipment, EQ_TYPE } from '../../_shared/interfaces/equipment';
import { TableListMultiGroup } from '../../_shared/table-list-multi';
import { User } from '../../_shared/interfaces/user';
import { createOrUpdateEquipment } from '../../_shared/services/manage-equipment.service';
import {
  getTandemGroups,
  updateTandemGroup,
} from '../../_shared/services/manage-tandem-groups.service';
import { SelectValue } from 'antd/lib/select';
import { Sidebar } from '../equipment-details/sidebar.component';
import colors from '../../_shared/colors';
import { cardStyles } from '../manage-equipment/manage-equipment.styles';
import { getFWErrorProps } from '../../_shared/fw-error-modal';
import { sendDeviceCommand } from '../../_shared/services/manage-schedule.service';
import { AIcon as Icon } from '../../_shared/icon';
import { WithForm } from '../../_shared/form';
import { WithAppConfig, AppConfig } from '../../_shared/hooks/useAppConfig';
import { trackEvent, } from '../../_shared/services/analytics.service';
import eventTypes from '../../_shared/interfaces/api/eventTypes';
import { ColumnProps } from 'antd/lib/table';

interface IProps extends RouteComponentProps {
  sState: AppState;
  updateMyEquipment: () => Promise<void>;
  form?: any;
  app?: AppConfig;
}

interface Opt {
  label: string;
  value: string | number;
  orgId?: string;
}

const EquipColumns = (_this: EditTandemGroup) => {
  return [
    {
      title: 'Select',
      dataIndex: '',
      width: '16.66%',
      render: (text: string, record: Equipment) => {
        const disabled =
          _this.state.selectedEquipment.length >= 4 &&
          !_this.state.selectedEquipment.includes(record.id as never);

        return (
          <Checkbox
            disabled={disabled}
            defaultChecked={_this.state.selectedEquipment.includes(
              record.id as never
            )}
            onChange={e => {
              if (!e.target.checked) {
                if (_this.state.central === record.id) {
                  _this.setState({ central: '' });
                }
                const selectedEquipment = _this.state.selectedEquipment.filter(
                  (equipId: string) => {
                    return equipId !== record.id;
                  }
                );
                if (selectedEquipment.length) {
                  _this.setState({ central: selectedEquipment[0] });
                }
                return _this.setState({ selectedEquipment });
              }

              if (!_this.state.selectedEquipment.length) {
                _this.setState({ central: record.id });
              }
              _this.setState({
                selectedEquipment: [
                  ..._this.state.selectedEquipment,
                  record.id,
                ],
              });
            }}
          />
        );
      },
    },
    {
      title: 'Serial Number',
      dataIndex: 'equipmentSN',
      width: ' 16.66%',
      defaultSortOrder: 'ascend',
      render: (text: string, record: Equipment) => {
        return (
          <span>{record.equipmentSN ? record.equipmentSN : record.name}</span>
        );
      },
      sorter: (a: Equipment, b: Equipment) => sortByKey(a, b, 'equipmentSN'),
    },
    {
      title: 'Model Id',
      dataIndex: 'modelId',
      width: '16.66%',
    },
    {
      title: 'Aeras Controller',
      dataIndex: 'controllerSerial',
      width: '16.66%',
      render: (text: string, record: Equipment) => {
        return <span>{record.controllerSerial}</span>;
      },
    },
    {
      title: 'Status',
      dataIndex: 'status',
      width: '16.66%',
      render: (text: string, e: Equipment) => {
        const config = getEquipConfig(e, _this.props.sState);
        return _this.renderStatus({
          equipment: e,
          loading: _this.state.loading,
          sState: _this.props.sState,
        });
      },
    },
    {
      title: 'Central',
      dataIndex: 'central',
      width: '16.66%',
      render: (text: string, record: Equipment) => {
        return (
          <Checkbox
            checked={_this.state.central === record.id}
            onChange={e => {
              if (e.target.checked) {
                return _this.setState({ central: record.id });
              }
              _this.setState({ central: '' });
            }}
          />
        );
      },
    },
  ].filter(f => f) as ColumnProps<any>[];
};

class EditTandemGroup extends Component<IProps> {
  state = {
    back: undefined,
    equipment: undefined,
    equip: undefined,
    model: undefined,
    showSideBar: undefined,
    tandemGroup: undefined as TandemGroup | undefined,
    loading: false,
    isEdit: false,
    isAdd: false,
    central: null,
    selectedEquipment: [],
    allEquipment: [],
    equipMap: {},
    tandemGroupOriginal: undefined,
  };

  // AER-1616: build the form items fresh on every render so that fields
  // dependent on current form state (Location/Equipment Type dropdowns gated
  // on `orgId`) re-evaluate their `disabled` flag and dependent `opts` as the
  // user fills in the form. Previously this list lived in `state.toDisplay`
  // and the `disabled` IIFE captured `getFieldValue('orgId')` at class
  // construction time — when the form hadn't mounted yet — so both
  // dropdowns stayed permanently disabled.
  //
  // AER-1465: each form field is capped to 400px individually (matching the
  // legacy formContainer width), but the Equipment section below is allowed
  // to break out and span the full content width — so the equipment table's
  // columns stay readable. The outer formContainer cap is dropped in render().
  getToDisplay = () => {
    const {
      form: { getFieldValue, getFieldsValue, setFieldsValue },
      sState,
      history: { location },
    } = this.props;
    const isEditFromHistory = get(location, 'state.editMode', true) as boolean;
    const tandemGroupFromHistory = get(
      location,
      'state.tandemGroup'
    ) as TandemGroup;
    const orgId = getFieldValue('orgId');

    return [
      {
        title: 'Name',
        var: 'name',
        style: 'max-width: 400px;',
        transform: (value: string) => uppercaseWords(value),
        options: {
          initialValue: get(
            this.props,
            'history.location.state.tandemGroup.name'
          ),
          rules: [
            {
              required: true,
              message: 'Name is required',
            },
            {
              max: 50,
              message: 'Name is limited to 50 characters. ',
            },
          ],
        },
      },
      {
        title: 'Organization',
        type: 'dropdown',
        var: 'orgId',
        style: 'max-width: 400px;',
        canDisplay: () => {
          return (
            !isEditFromHistory ||
            (isEditFromHistory && !get(tandemGroupFromHistory, 'locationId'))
          );
        },
        onChange: (value: SelectValue) => {
          const { locationId, equipType } = getFieldsValue([
            'locationId',
            'equipType',
          ]);
          const { central, selectedEquipment } = this.state;
          if (locationId) setFieldsValue({ locationId: '' });
          if (equipType) setFieldsValue({ equipType: '' });
          if (central) this.setState({ central: '' });
          if (selectedEquipment.length) this.setState({ equipment: [] });
        },
        opts: sState.dash.orgs
          .filter((org: Org) => org.orgType === 1)
          .map(o => ({ label: o.name, value: o.id } as Opt))
          .sort(sortByLabel),
        options: {
          initialValue: get(this.props, 'history.location.state.orgId'),
          rules: [
            {
              required: true,
              message: 'Organization is required',
            },
          ],
        },
      },
      {
        title: 'Location',
        type: 'dropdown',
        var: 'locationId',
        style: 'max-width: 400px;',
        canDisplay: () => {
          return (
            !isEditFromHistory ||
            (isEditFromHistory && !get(tandemGroupFromHistory, 'locationId'))
          );
        },
        onChange: (value: SelectValue) => {
          const { equipType } = getFieldsValue(['locationId', 'equipType']);
          const { central, selectedEquipment } = this.state;
          if (equipType) setFieldsValue({ equipType: '' });
          if (central) this.setState({ central: '' });
          if (selectedEquipment.length) this.setState({ equipment: [] });
        },
        opts: () => {
          const isSuper = userHasRole([0, 1], sState);
          const isSOAdmin = isServiceOrgAdmin(sState);
          const opts = get(sState, 'dash.locations', []).map(
            (m: Location) => ({
              label: m.name,
              value: m.id,
              orgId: m.orgId,
            })
          );
          if (isSuper || isSOAdmin) {
            return opts
              .filter((opt: Opt) => opt.orgId === orgId)
              .sort(sortByLabel);
          } else {
            return opts
              .filter(
                (opt: Opt) =>
                  opt.orgId === get(sState, 'auth.user.orgId')
              )
              .sort(sortByLabel);
          }
        },
        options: {
          initialValue: get(this.props, 'history.location.state.locationId'),
          rules: [
            {
              required: true,
              message: 'Location is required',
            },
          ],
        },
        props: {
          disabled: !orgId,
        },
      },
      {
        title: 'Equipment Type',
        type: 'dropdown',
        var: 'equipType',
        style: 'max-width: 400px;',
        canDisplay: () => {
          const isEdit = get(
            location,
            'state.editMode',
            this.state.isEdit
          ) as boolean;
          return isEdit ? false : true;
        },
        onChange: (value: SelectValue) => {
          const { central, selectedEquipment } = this.state;
          if (central) this.setState({ central: '' });
          if (selectedEquipment.length) this.setState({ equipment: [] });
        },
        opts: [
          {
            label: EQ_TYPE.Compressor,
            value: EQ_TYPE.Compressor,
          },
          {
            label: EQ_TYPE.Vacuum,
            value: EQ_TYPE.Vacuum,
          },
        ],
        options: {
          initialValue: !!get(this.props, 'history.location.state.equipment')
            ? getEquipmentType(
                get(this.props, 'history.location.state.equipment.equipmentSN'),
                get(this.props, 'history.location.state.equipment.modelId')
              )
            : undefined,
          rules: [
            {
              required: true,
              message: 'Equipment Type is required',
            },
          ],
        },
        props: {
          disabled: !orgId,
        },
      },
    ];
  };

  componentDidMount = async () => {
    const {
      sState,
      history: { location },
    } = this.props;
    const back = get(location, 'state.back');
    const showSideBar = get(location, 'state.showSideBar');
    const tandemGroup = get(location, 'state.tandemGroup', new _TandemGroup());
    const equipment: any = get(location, 'state.equipment');
    const model = equipment && getEquipmentModel(equipment, sState);
    const tandemGroupOriginal = get(location, 'state.tandemGroup');
    const isEdit = get(location, 'state.editMode', this.state.isEdit);
    const isAdd = get(location, 'state.isAdd', false);
    const allEquipment = get(
      this.props,
      'sState.dash.equipment',
      []
    ) as Equipment[];
    const equipMap = chain(allEquipment)
      .keyBy('id')
      .value();

    const tgEquipment = allEquipment.filter(
      eq => eq.tandemGroupId === get(tandemGroupOriginal, 'id')
    );
    const centralEq = tgEquipment.find(eq => eq.tandemGroupRole === 'central');

    let selectedEquipment: any[] = [];
    if (equipment) {
      selectedEquipment.push(equipment.id);
    }

    this.setState({
      back,
      tandemGroup,
      isAdd,
      isEdit,
      central: get(centralEq, 'id') || get(equipment, 'id'),
      equipment: tgEquipment,
      allEquipment,
      tandemGroupOriginal,
      showSideBar,
      equip: equipment,
      model,
      equipMap,
      selectedEquipment,
    });
  };

  sendDevComAndUpdateEq = async (tandemGroup: TandemGroup) => {
    const { equipMap, selectedEquipment, central } = this.state;
    const centralEquipment: any = get(equipMap, `[${central}]`);
    const peerEquipmentIds = selectedEquipment.filter(id => id !== central);
    const peerEquipment = peerEquipmentIds.map(id => get(equipMap, `[${id}]`));
    try {
      const arg = generateTGDeviceCMD(
        tandemGroup.groupNumber,
        TG_ROLES.CENTRAL
      );
      const centralConfig = getEquipConfig(centralEquipment, this.props.sState);
      const centFWVersion: number = get(centralConfig, 'fw_version');
      if (centFWVersion < 34) {
        return this.props.app.modal.error(getFWErrorProps(
          centralEquipment.equipmentSN,
          centFWVersion.toString()
        ));
      }
      await sendDeviceCommand(
        centralEquipment.deviceId,
        { arg },
        {
          tandem: {
            tandemGroupNumber: tandemGroup.groupNumber,
            tandemGroupRole: TG_ROLES.CENTRAL,
          },
        }
      );
      message.success(
        `${centralEquipment.equipmentSN} has been added to Tandem Group ${tandemGroup.name}`
      );
      peerEquipment.length &&
        (await Promise.all(
          peerEquipment.map(async (equipment: any) => {
            const config = getEquipConfig(equipment, this.props.sState);
            const FWVersion: number = get(config, 'fw_version');
            if (FWVersion < 34) {
              return this.props.app.modal.error(getFWErrorProps(
                equipment.equipmentSN,
                FWVersion.toString()
              ));
            }
            try {
              const arg = generateTGDeviceCMD(
                tandemGroup.groupNumber,
                TG_ROLES.PEER
              );
              await sendDeviceCommand(
                equipment.deviceId,
                { arg },
                {
                  tandem: {
                    tandemGroupNumber: tandemGroup.groupNumber,
                    tandemGroupRole: TG_ROLES.PEER,
                  },
                }
              );
              message.success(
                `${equipment.equipmentSN} has been added to tandem group ${tandemGroup.name}`
              );
            } catch (error) {
              message.error(
                `${equipment.equipmentSN} could not be added to tandem group ${tandemGroup.name}`
              );
            }
          })
        ));
      return true;
    } catch (error) {
      message.error(
        `${centralEquipment.equipmentSN} could not be added to tandem group ${tandemGroup.name}`
      );
      throw new Error();
    }
  };

  verifyTG = (isAdd: boolean, isEdit: boolean) => {
    if (!isEdit && isAdd && !this.state.selectedEquipment.length) {
      message.error('You must select 1-4 pieces of equipment for this Tandem Group.');
      this.setState({
        loading: false,
      });
      return false;
    }
    if (!isEdit && isAdd && !this.state.central) {
      // tslint:disable-next-line: max-line-length
      message.error('You must select one piece of equipment as the Central equipment for this tandem group.');
      this.setState({
        loading: false,
      });
      return false;
    }
    if (
      !isEdit &&
      !this.state.selectedEquipment.includes(this.state.central as never)
    ) {
      message.error('Central equipment must be a member of the tandem group.');
      this.setState({
        loading: false,
      });
      return false;
    }
    return true;
  };

  submit = async (e: MouseEvent | FormEvent) => {
    stopProp(e);
    if (this.state.loading) {
      return;
    }

    if (userHasRole([7], this.props.sState)) {
      this.props.app.modal.warning({
        title: 'Functionality Not Available',
        content:
          //tslint:disable-next-line: max-line-length
          'Your user account does not have access to complete this functionality.\
          If you feel that this is incorrect, please contact your company Admin.',
        onOk: () => {
          return 0;
        },
      });

      return;
    }

    this.state.loading = true;
    this.setState(this.state);
    const { tandemGroup } = this.state;

    this.props.form.validateFieldsAndScroll(async (err: any, values: any) => {
      if (err) {
        const error = buildErrorMsgFromForm(err);
        message.error(error);
        return this.setState({ loading: false });
      }

      try {
        const originalTandem = cleanCopy(tandemGroup);

        const _tandemGroup = new _TandemGroup({
          ...((tandemGroup as TandemGroup) || {}),
        } as any) as TandemGroup;
        this.getToDisplay().map(item => {
          const val = values[item.var];
          _tandemGroup[item.var] = (item as any).transform ? (item as any).transform(val) : val;
        });
        const isEdit = get(this.state, 'isEdit', true);
        const isAdd = get(this.state, 'isAdd', false);
        const date = new Date().toISOString();
        const currentUser = get(this.props.sState, 'auth.user', {}) as User;
        const groupNumber = Math.floor(moment().valueOf() / 1000);

        set(_tandemGroup, 'updatedAt', date);
        set(_tandemGroup, 'updatedBy', currentUser.userId);
        if (isEdit && !_tandemGroup.equipType) {
          delete _tandemGroup.orgId;
          set(_tandemGroup, 'equipType', get(tandemGroup, 'equipType'));
        }
        if (isEdit && !_tandemGroup.locationId) {
          set(_tandemGroup, 'locationId', get(tandemGroup, 'locationId'));
        }
        const canContinue = this.verifyTG(isAdd, isEdit);
        if (!canContinue) return;

        let location;

        if (isAdd) {
          set(_tandemGroup, 'groupNumber', groupNumber);
          const procede = await this.sendDevComAndUpdateEq(_tandemGroup);
          if (procede) {
            const response = await getTandemGroups({
              groupNumber: { eq: _tandemGroup.groupNumber },
            });
            const newTandemGroup = get(response, '0');
            if (newTandemGroup) {
              set(newTandemGroup, 'name', _tandemGroup.name);
              // AER-1692: was `currentUser.id` — `User` has no `id`, only
              // `userId` (line ~584 above gets it right). The typo compiled
              // because User carries an index signature, wrote `undefined`,
              // and removeEmpty() then stripped the key entirely. Since the
              // DynamoDB put replaces the whole item, that also erased any
              // createdBy the server-side create had already stamped.
              set(newTandemGroup, 'createdBy', currentUser.userId);
              await updateTandemGroup(newTandemGroup);
            }
          }
        } else {
          const equipment = (get(this, 'props.sState.dash.equipment') as any[]).filter(
            (e: Equipment) => get(e, 'tandemGroupId') === _tandemGroup.id
          ) as Equipment[];
          const equipmentNoLoc = equipment.filter(eq => !eq.locationId);
          const allLocations = get(
            this.props,
            'sState.dash.locations',
            []
          ) as Location[];
          location = allLocations.find(
            loc => loc.id === values.locationId
          ) as Location;
          if (equipmentNoLoc.length) {
            return this.showAddLocToEquipModal(
              equipmentNoLoc,
              location,
              _tandemGroup
            );
          } else {
            await updateTandemGroup(_tandemGroup);
          }
        }
        await this.props.updateMyEquipment();
        message.success(
          isAdd
            ? 'New tandem group has been created!'
            : 'Tandem group has been saved'
        );

        trackEvent(
          isAdd ? eventTypes.tandem_add : eventTypes.tandem_update,
          isAdd
            ? {
              tandemGroup: _tandemGroup,
              org: get(this, 'props.sState.dash.orgs', []).find(
                (o: Org) => o.id === _tandemGroup.orgId
              ),
              location,
            }
            : { old: originalTandem, new: _tandemGroup }
        );

        this.setState({
          loading: false,
          isEdit: false,
          tandemGroup: _tandemGroup,
        });

        if (get(this.state, 'back', '').includes('Equipment')) {
          this.goBack();
        } else {
          this.manageTandemGroup(_tandemGroup);
        }
      } catch (error) {
        message.error('Tandem Group could not be created');
        return this.setState({
          loading: false,
        });
      }
    });
  };

  showAddLocToEquipModal = (
    equip: Equipment[],
    loc: Location,
    _tandemGroup: TandemGroup
  ) => {
    this.props.app.modal.confirm({
      title: 'Add Equipment to Location?',
      content: (
        <div>
          <p>The following equipment are not associated with a location: </p>
          {equip.map(eq => {
            return <span> - {eq.equipmentSN || eq.name}</span>;
          })}
          <br />
          <p>
            Do you want to add these equipment to the same location as tandem
            group {_tandemGroup.name}?
          </p>
        </div>
      ),
      onOk: async () => {
        try {
          await updateTandemGroup(_tandemGroup);
          message.success(
            `Successfully updated tandem group ${_tandemGroup.name}`
          );
          equip.map(async eq => {
            const me: any = get(this.props, 'sState.auth.user');
            set(eq, 'updatedAt', moment().toISOString());
            set(eq, 'updatedBy', me.userId);
            set(eq, 'locationId', loc.id);
            try {
              await createOrUpdateEquipment(eq);
              message.success(
                `Successfully updated equipment ${eq.equipmentSN || eq.name}`
              );
            } catch (error) {
              message.error(
                `Could not update equipment ${eq.equipmentSN || eq.name}`
              );
            }
          });
          this.setState({
            loading: false,
            isEdit: false,
            tandemGroup: _tandemGroup,
          });

          this.manageTandemGroup(_tandemGroup);
        } catch (error) {
          message.error(`Could not update tandem group ${_tandemGroup.name}`);
        }
      },
      okText: 'YES',
      cancelText: 'NO',
      onCancel: () => 0,
    });
  };

  setFieldsOriginal = () => {
    const { tandemGroup } = this.state;
    const {
      form: { setFieldsValue },
    } = this.props;

    const TandemGroup = new _TandemGroup({
      ...(tandemGroup || {}),
    } as TandemGroup);
    this.getToDisplay().map(item => {
      setFieldsValue({ [item.var]: TandemGroup[item.var] });
    });
  };

  goBack = () => {
    this.setFieldsOriginal();
    this.props.history.goBack();
  };

  manageTandemGroup = (tandemGroup: TandemGroup) => {
    this.props.history.push('/dashboard/manageTandemGroups', {
      tandemGroup,
    });
  };

  goToBillingHistory = (equipmentId: string) => { };

  renderEquipTable = () => {
    const { loading } = this.state;
    const {
      form: { getFieldValue },
    } = this.props;
    const allEquip = get(this.state, 'allEquipment');
    const equipment = allEquip.filter(
      (equip: {
        locationId: string;
        equipmentSN: string;
        modelId: string;
        tandemGroupId: string;
        controllerSerial: string;
        id: string;
      }) => {
        const {
          form: { getFieldValue },
        } = this.props;
        const eqType = getFieldValue('equipType');
        const locationId = getFieldValue('locationId');
        return (
          equip.locationId === locationId &&
          getEquipmentType(equip.equipmentSN, equip.modelId) === eqType &&
          !equip.tandemGroupId
        );
      }
    );
    // AER-1465: the v3 build let nested tables break out of the 400px
    // formContainer cap; antd v6 honors it. We've moved the 400px cap onto
    // each form field (see toDisplay entries above) so this wrapper just
    // needs to span the form's full width — no max-width override required.
    return (
      <div css={css(`margin-bottom: 50px; width: 100%;`)}>
        <TableListMultiGroup
          css={css(`margin-bottom: 50px`)}
          data={equipment as never}
          loading={loading}
          columns={EquipColumns(this)}
          canSelectRows={false}
          canShowAdd={false}
          title={'Equipment'}
          variable={'equipment'}
          allOpts={allEquip as never}
          totalTitle={(count: number) => `Total Equipment: ${count}`}
          blankText={
            getFieldValue('equipType')
              ? `No ${getFieldValue(
                  'equipType'
                )}s are available to be added to a tandem group at this location. `
              : 'No equipment is available to be added to a tandem group at this location. '
          }
          subtitle={
            // tslint:disable-next-line: max-line-length
            'Select up to 4 pieces of equipment to add to the tandem group. The first device you select will be designated as the central device, but that can be changed if desired. The central device coordinates communication between all tandem devices. If any other device goes down the tandem group will self-heal, but if the central device goes down the remaining devices will transition to standalone mode and continue running without intelligent tandem functionality. If one device is newer it is recommended to use that as the central device.'
          }
        />
      </div>
    );
  };

  renderStatus = (props: {
    equipment: Equipment;
    loading: boolean;
    sState: AppState;
  }) => {
    const { loading, equipment } = props;

    const deviceState = getDeviceStatusFromEquip(equipment);
    const deviceStatus: string = deviceState.deviceStatus;
    const opt: {
      [key: string]: { color: string; label: string; canDisplay?: boolean };
    } = {
      loading: { color: colors.statusOff, label: 'loading' },
      off: { color: colors.statusOff, label: 'Offline' },
      standby: { color: colors.statusStandby, label: 'Standby' },
      on: { color: colors.statusOn, label: 'On' },
    };
    const renderLabel = (option: { label: string; color: string }) => {
      return (
        <div
          key={option.label}
          css={css(cardStyles.cardStatus, { backgroundColor: option.color })}
        >
          {option.label}
          {loading && <Icon css={css('margin-left: 2px;')} type="loading" />}
        </div>
      );
    };

    return loading ? (
      <div css={css(cardStyles.statusContainer)}>
        {loading ? renderLabel(opt.loading) : renderLabel(opt[deviceStatus])}
      </div>
    ) : (
      '--'
    );
  };
  render() {
    const {
      back,
      tandemGroup,
      loading,
      isAdd,
      equip,
      model,
      showSideBar,
      selectedEquipment,
    } = this.state;
    const toDisplay = this.getToDisplay();
    const { sState, app } = this.props;
    const ispb = isPB(sState);
    const { getFieldValue, Form } = this.props.form;
    const showEquipTable =
      (!!getFieldValue('locationId') && !!getFieldValue('equipType')) ||
      !!this.state.selectedEquipment.length;
    const config = getEquipConfig(equip, sState);
    return (
      <div css={css(styles.container)}>
        {!!back && (
          <Link
            css={css`
              margin-bottom: 5px;
            `}
            onClick={this.goBack}
          >
            {back}
          </Link>
        )}
        <div
          css={css(
            styles.container,
            !ispb && `flex-direction: row;`,
            ispb && 'margin-bottom: 0px;'
          )}
        >
          {!ispb && showSideBar && (
            <Sidebar
              equipment={(equip as unknown) as Equipment}
              model={model}
              // @ts-ignore: config from getEquipConfig is loosely typed
              config={config}
              goToBillingHistory={this.goToBillingHistory}
            />
          )}
          {tandemGroup ? (
            <div css={css(styles.mainContainer, showSideBar && `border-left: 2px solid ${app.getColor('inputBorder')}`)}>
              <FormTitle
                size={'20px'}
                title={
                  !!back && isAdd ? 'Add Tandem Group' : 'Edit Tandem Group'
                }
              />

              {/*
                AER-1465: drop the legacy 400px formContainer cap on the
                wrapper so the Equipment section below (table, subtitle,
                empty-state copy) reaches the full content width like the v3
                build did. Each form field is individually capped via its
                `style: 'max-width: 400px;'` entry in `toDisplay` to keep
                the input column at its original width.
              */}
              <div css={css(`height: 100%;`)}>
                <Form
                  layout="vertical"
                  onSubmit={this.submit}
                  items={toDisplay}
                  forceUpdate={this}
                >
                  {showEquipTable && this.renderEquipTable()}

                  <Button
                    title={'Cancel'}
                    disabled={loading}
                    css={css`
                      margin-right: 10px;
                    `}
                    outline={true}
                    onClick={this.goBack}
                  />
                  <Button
                    title={'Save'}
                    loading={loading}
                    onClick={this.submit}
                  />
                </Form>
              </div>
            </div>
          ) : (
            <div>No Tandem Group Provided</div>
          )}
        </div>
      </div>
    );
  }
}

export const EditTandemGroupComponent = WithAppConfig(WithForm(withRouter(EditTandemGroup)));
